// css文件，需在提前引入
import "@/assets/styles/index.less";

import "@/window.js"; // TODO: 必须放在项目前面运行
import dsh, { https } from "ms-vtools";

import Vue from "vue";
import App from "./App.vue";
import "@/components/index.js"; // 全局组件
import "@/data/index.js"; // 挂载在prototype的数据
import "@/global/index.js"; // 全局的东西

import store from "@/store/index.js";
import router from "@/router/index.js";

/**
* @description 接口工具的配置 -请求状态，响应状态
*/
const axios = https.axios;
axios.interceptors.request.use(function (configParam) {
    configParam.headers.authtoken = window.localStorage.getItem("authtoken");
    return configParam;
}, function (error) {
    return Promise.reject(error);
});
axios.interceptors.response.use(res => {
    // 登录状态失效，返回登录页
    if (res && res.res === 400003) {
        Vue.prototype.$goSso();
    }
    return res;
});

// 安装核心工具
Vue.use(dsh, {
    socketUrl: window.config.socketUrl
});

// 设置为 false 以阻止 vue 在启动时生成生产提示。
Vue.config.productionTip = false;
export default new Vue({
    el: "#app",
    store,
    router,
    render: h => h(App)
});



// WEBPACK FOOTER //
// ./src/main.js